import React from "react";

// Router
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// components
import Modal from "./components/Modals";
import Cookies from "components/Cookie";
import Messages from "components/Messages";
import Loader from "components/UiKit/Loader";
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import SmartLoader from "components/SmartLoader";
import PrivateRoute from "./components/PrivateRouter";
import TutorialManagerWrapper from './components/TutorialManager/TutorialManagerWrapper';

// Lib
import AmplitudeInitialTrigger from "./lib/amplitude-initial-trigger";

// Pages
const RequestForm = React.lazy(() =>
  import("./pages/RequestForm").then((module) => ({ default: module.default }))
);

const Auth = React.lazy(() =>
  import("./pages/Auth").then((module) => ({ default: module.default }))
);

const Terms = React.lazy(() =>
  import("./pages/Terms").then((module) => ({ default: module.default }))
);

const Pfizer = React.lazy(() =>
  import("./pages/Pfizer").then((module) => ({ default: module.default }))
);

const Main = React.lazy(() =>
  import("./pages/Main").then((module) => ({ default: module.default }))
);

const Policy = React.lazy(() =>
  import("./pages/Policy").then((module) => ({ default: module.default }))
);

const Projects = React.lazy(() =>
  import("./pages/Projects").then((module) => ({ default: module.default }))
);

const Services = React.lazy(() =>
  import("./pages/Services").then((module) => ({ default: module.default }))
);

const Account = React.lazy(() =>
  import("./pages/Account").then((module) => ({ default: module.default }))
);

const AboutUs = React.lazy(() =>
  import("./pages/AboutUs").then((module) => ({ default: module.default }))
);

const Checkout = React.lazy(() =>
  import("./pages/Checkout").then((module) => ({ default: module.default }))
);

const NotFound = React.lazy(() =>
  import("./pages/NotFound").then((module) => ({ default: module.default }))
);

const Libraries = React.lazy(() =>
  import("./pages/Libraries").then((module) => ({ default: module.default }))
);

const ContactUs = React.lazy(() =>
  import("./pages/ContactUs").then((module) => ({ default: module.default }))
);

const ForgotPassword = React.lazy(() =>
  import("./pages/ForgotPassword").then((module) => ({ default: module.default }))
);

const ImpuritiesForDrug = React.lazy(() =>
  import("./pages/ImpuritiesForDrug").then((module) => ({ default: module.default }))
);

const Impurities = React.lazy(() =>
  import("./pages/AllDrugsVocabulary").then((module) => ({ default: module.default }))
);

const ChemicalProbes = React.lazy(() =>
  import("./pages/ChemicalProbes").then((module) => ({ default: module.default }))
);

const MoleculeProduct = React.lazy(() =>
  import("./pages/MoleculeProduct").then((module) => ({ default: module.default }))
);

const Search = React.lazy(
  () => import("./pages/Search").then((module) => ({ default: module.default }))
);

const LibrariesProduct = React.lazy(() =>
  import("./pages/LibrariesProduct").then((module) => ({ default: module.default }))
);

const LibrariesCompounds = React.lazy(() =>
  import("./pages/LibrariesCompounds").then((module) => ({ default: module.default }))
);

export default (
  <Router>
    <React.Suspense fallback={<Loader type="global" />}>
      <Modal />
      <Messages />
      <Header />
      <TutorialManagerWrapper />
      <Routes>
        <Route element={<PrivateRoute />}>
          <Route path="/account" element={<Account />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/checkout" element={<Checkout />} />
        </Route>

        <Route path="/" element={<Main />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/search" element={<Search />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/services" element={<Services />} />
        <Route path="/libraries" element={<Libraries />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/privacy-policy" element={<Policy />} />
        <Route path="/impurities" element={<Impurities />} />
        <Route path="/categorized-products/:slug" element={<Pfizer />} />
        <Route path="/terms-of-service" element={<Terms />} />
        <Route path="/request-form" element={<RequestForm />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/chemical-probes" element={<ChemicalProbes />} />
        <Route path="/impurities/:id" element={<ImpuritiesForDrug />} />
        <Route path="/molecule-product/:id" element={<MoleculeProduct />} />
        <Route path="/libraries-product/:id" element={<LibrariesProduct />} />
        <Route path="/libraries-compounds/:id" element={<LibrariesCompounds />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
      <Cookies />
      <SmartLoader />
      <AmplitudeInitialTrigger />
      <Footer />
    </React.Suspense>
  </Router>
);